import React, { Component } from 'react';
import style from './index.module.css';

interface Chapter1State {
  days: number;
}

class Chapter1 extends Component<any, Chapter1State> {
  constructor(props) {
    super(props);
    this.state = {
      days: 0
    };
  }
  componentDidMount() {
    const { timeStamp } = this.props.data;
    if (timeStamp) {
      let myDate = new Date();
      let newData = myDate.getTime(); //获取当前毫秒数(0-999)
      let timeDiff = newData - timeStamp;
      let daysDiff = Math.floor(timeDiff / (24 * 3600 * 1000));
      console.log(daysDiff);
      this.setState({
        days: daysDiff
      });
    }
  }

  render() {
    const { status, deliverTime, isMultiCar, rule } = this.props.data;
    // if (status === 0) return;
    const { setInstructionModel } = this.props;
    const { days } = this.state;

    return (
      <div
        className={style.pageBox}
        style={{
          height: document.documentElement.clientHeight
        }}
      >
        {isMultiCar && rule && (
          <div
            className={style.instructionsIconBox}
            onClick={() => setInstructionModel(rule)}
          />
        )}
        {status === 1 && (
          <div className={style.itemBox}>
            {/* <div className={style.xpIconBox} style={{ marginBottom: 0 }} /> */}
            <span className={style.blueBigText}>Hi，鹏友</span>
            <p className={style.grayNormalText} style={{ marginTop: 10 }}>
              一路相伴，我们一起见证了许多美好的回忆
            </p>
          </div>
        )}
        {status === 2 && (
          <div className={style.itemBox}>
            <div className={style.xpIconBox} />
            <p className={style.ordinaryText}>
              <span className={style.blueBigText}>{deliverTime}</span>
              你终于来到了我们的身边
              <br />
              <br />
              <span className={style.grayNormalText}>
                往后漫漫旅途，我们陪你满电出发
              </span>
            </p>
          </div>
        )}
        {status === 3 && (
          <div className={style.itemBox}>
            <p className={style.ordinaryText}>
              还记得<span className={style.blueNormalText}>{deliverTime}</span>
              吗？
              <br />
              这天起你多了一个与众不同的身份
              <br />
              <span className={style.blueBigText} style={{ marginTop: 0 }}>
                鹏友
              </span>
              光阴如电，你与小鹏已走过
              <span className={style.blueNormalText}>{days || '---'}</span>
              个日夜
              <br />
              <br />
              <span className={style.grayNormalText}>
                一路相伴，我们一起见证了许多美好回忆
              </span>
            </p>
          </div>
        )}
        <div className={style.chapter1Icon} />
      </div>
    );
  }
}

export default Chapter1;
